import { inject, Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RoomType } from '../models/room-type.enum';

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'translateRoom'
})
export class TranslateRoomPipe implements PipeTransform {
    private readonly translate = inject(TranslateService);

    transform(value: string | null | undefined): string {
        if (!value) {
            return '';
        }
        if ((Object.values(RoomType) as string[]).includes(value)) {
            return this.translate.instant(`RBR.ROOM_TYPE.${value}`);
        }
        return value;
    }
}
